module.exports = __webpack_public_path__ + "static/art-5-0a8cf1740deee3264e986df9ddd6c6eb.jpg";